const base = "cui-body-o5xe";
const l = "cui-body-l-sawa";
const m = "cui-body-m-mwmz";
const s = "cui-body-s-lehd";
const regular = "cui-body-regular-hd7o";
const semibold = "cui-body-semibold-pt76";
const bold = "cui-body-bold-6y5i";
const italic = "cui-body-italic-2aq6";
const strikethrough = "cui-body-strikethrough-pff0";
const normal = "cui-body-normal-pvqj";
const subtle = "cui-body-subtle-5ogj";
const placeholder = "cui-body-placeholder-gu2c";
const accent = "cui-body-accent-gkhh";
const success = "cui-body-success-4wck";
const warning = "cui-body-warning-dzft";
const danger = "cui-body-danger-apdm";
const promo = "cui-body-promo-skod";
const highlight = "cui-body-highlight-kmah";
const quote = "cui-body-quote-tpvn";
const confirm = "cui-body-confirm-fov1";
const alert = "cui-body-alert-dfxx";
const classes = {
  base,
  l,
  m,
  s,
  regular,
  semibold,
  bold,
  italic,
  strikethrough,
  normal,
  subtle,
  placeholder,
  "on-strong": "cui-body-on-strong-lxsu",
  "on-strong-subtle": "cui-body-on-strong-subtle-icor",
  accent,
  success,
  warning,
  danger,
  promo,
  highlight,
  quote,
  confirm,
  alert
};
export {
  accent,
  alert,
  base,
  bold,
  confirm,
  danger,
  classes as default,
  highlight,
  italic,
  l,
  m,
  normal,
  placeholder,
  promo,
  quote,
  regular,
  s,
  semibold,
  strikethrough,
  subtle,
  success,
  warning
};
